import URLHelper from "base/URLHelper";
import Page from "webPage/Page";

export function svg_include(icon, suffix = '') {
    return '<svg><use xlink:href="' + get_svg_includes_url(suffix) + '#' + icon + '"></use></svg>';
}

export function get_svg_includes_url(suffix = '') {
    return suffix.trim().length === 0 || 'undefined' === typeof window.CONFIG.svgIncludesFiles[suffix] ? window.CONFIG.svgIncludes : window.CONFIG.svgIncludesFiles[suffix];
}

export function admin_svg_include(icon, module = "base") {
    return '<svg><use xlink:href="' + window.CONFIG.adminBuildUrl + module + '/icons.svg#' + icon + '"></use></svg>';
}

export function load_json_from_element($element) {
    if ($element.length === 0) return null;

    let json = $element.text();

    return JSON.parse(json);
}

export function pluralise_word(count, suffix, plural_suffix = "s", append_suffix = true) {
    return count + (count !== 1 ? (append_suffix ? suffix : "") + plural_suffix : suffix);
}

export function redirect_to_next(defaultUrl) {
    window.location.href = get_next_url(defaultUrl);
}

export function get_next_url(defaultUrl) {
    let next = Page.get_query().next;

    if (!next || !URLHelper.is_site_url(next)) {
        return defaultUrl;
    }

    return next;
}
